import React from "react";
import { UnauthenticatedPage } from "pages/layouts";
import { useQuery } from "hooks/useQuery";
import { LicenceCheckingService } from "services";
import { DeclarationWizard } from "pages/licence-checking/declaration-wizard";

export function LicenceCheckingConsent() {
    const query = useQuery();
    const employee = query.get("employee");
    const code = query.get("code");
    const email = query.get("email");

    function loadDetails() {
        return LicenceCheckingService.getConsent(employee, code, email);
    }

    function saveDetails(consent, { consentId }) {
        // The email-link flow preserves the original payload shape by appending the identifiers from the URL.
        return LicenceCheckingService.saveConsent(consentId, {
            ...consent,
            email: email,
            token: code,
            employee: employee,
        });
    }

    function refuseDetails({ consentId }) {
        return LicenceCheckingService.rejectConsent(consentId, {
            email: email,
            token: code,
            employee: employee,
        });
    }

    return (
        <UnauthenticatedPage>
            <DeclarationWizard
                loadDetails={loadDetails}
                saveDetails={saveDetails}
                refuseDetails={refuseDetails}
            />
        </UnauthenticatedPage>
    );
}
